import { useState } from "react";
import { Checkbox } from "@mui/material";
import { ThemeInput } from "components/components";
import { Button, message } from "antd";

const Mollie = () => {
  const [showFields, setShowFields] = useState(false);
  const onChange = (e) => {
    setShowFields(e.target.checked);
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(
      "https://demo-saas.worksuite.biz/paystack-webhook/3a835e0ccbbd218f87c62a440878d64d"
    );
    message.success("Webhook URL Copied!");
  };
  return (
    <div className="bg-themeGray-light200 p-3 -mt-4 -ml-2 min-h-[70vh] desktop:h-[76vh] bigDesktop:h-[83vh]">
      <div className="bg-white p-3 shadow-md">
        <div className="flex items-center">
          <Checkbox onChange={onChange} />
          <p>Mollie Status</p>
        </div>
        {showFields && (
          <div>
            <ThemeInput placeholder={"Mollie Key"} password />
            <Button
              type="primary"
              className="mt-2 w-full"
              onClick={() => message.success("Successfully saved settings")}
            >
              Save
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Mollie;
